<div class="equipment-counting-metrics-container">
  <!-- Slicers Section with Refresh Button -->
  <div class="slicers-row">
    <stack-mono-equipment-counting-slicers
      [filters]="filters"
      [showClearFilter]="showClearFilter"
      [resetFilters]="resetFilters"
      [dateRange]="countingDateRange"
      (slicerChange)="onSlicerChange($event)"
      (slicerClose)="onSlicerClose($event)"
      (clearFiltersClick)="clearFilters()"
      (dateRangeChange)="onCountingDateRangeChange($event)"
      (customDateRangeChange)="onCustomDateRangeChange($event)"
    ></stack-mono-equipment-counting-slicers>
    <button
      nbButton
      ghost
      status="primary"
      size="small"
      class="refresh-button"
      (click)="refreshData()"
      [disabled]="isLoadingMetrics || isLoadingDispositionData"
      nbTooltip="Refresh data"
      nbTooltipPlacement="left"
      >
      <nb-icon
        icon="refresh-outline"
        [class.spinning]="isLoadingMetrics || isLoadingDispositionData"
      ></nb-icon>
    </button>
  </div>

  <!-- Metrics Cards Section -->
  <div class="row mt-3">
    <!-- Journal Summary Card -->
    <div class="col-md-6">
      <nb-card>
        <nb-card-header>
          <h6>JOURNAL SUMMARY</h6>
        </nb-card-header>
        <nb-card-body style="overflow: visible; padding: 2rem 0rem 1rem 0rem">
          <div class="metrics-container">
            <div class="metric-row">
              <div
                class="metric-item clickable"
                (click)="showJournalsByStatus(null)"
                (keydown.enter)="showJournalsByStatus(null)"
                tabindex="0"
                role="button"
                nbTooltip="View all journals"
                nbTooltipPlacement="top"
                >
                <div class="metric-value">
                  @if (isLoadingMetrics) {
                    <div class="inline-spinner"></div>
                  }
                  @if (!isLoadingMetrics && metrics) {
                    <span>{{
                      formatMetricValue(metrics.totalJournals)
                    }}</span>
                  }
                </div>
                <div class="metric-label">TOTAL</div>
              </div>
              <div
                class="metric-item clickable"
                (click)="showJournalsByStatus('Ready')"
                (keydown.enter)="showJournalsByStatus('Ready')"
                tabindex="0"
                role="button"
                nbTooltip="View ready journals"
                nbTooltipPlacement="top"
                >
                <div
                  class="metric-value"
                  [style.color]="getJournalStatusColor('Ready')"
                  >
                  @if (isLoadingMetrics) {
                    <div class="inline-spinner"></div>
                  }
                  @if (!isLoadingMetrics && metrics) {
                    <span>{{
                      formatMetricValue(metrics.readyJournals)
                    }}</span>
                  }
                </div>
                <div class="metric-label">READY</div>
              </div>
              <div
                class="metric-item clickable"
                (click)="showJournalsByStatus('InProgress')"
                (keydown.enter)="showJournalsByStatus('InProgress')"
                tabindex="0"
                role="button"
                nbTooltip="View in progress journals"
                nbTooltipPlacement="top"
                >
                <div
                  class="metric-value"
                  [style.color]="getJournalStatusColor('InProgress')"
                  >
                  @if (isLoadingMetrics) {
                    <div class="inline-spinner"></div>
                  }
                  @if (!isLoadingMetrics && metrics) {
                    <span>{{
                      formatMetricValue(metrics.inProgressJournals)
                    }}</span>
                  }
                </div>
                <div class="metric-label">IN PROGRESS</div>
              </div>
              <div
                class="metric-item clickable"
                (click)="showJournalsByStatus('Recount')"
                (keydown.enter)="showJournalsByStatus('Recount')"
                tabindex="0"
                role="button"
                nbTooltip="View recount journals"
                nbTooltipPlacement="top"
                >
                <div
                  class="metric-value"
                  [style.color]="getJournalStatusColor('Recount')"
                  >
                  @if (isLoadingMetrics) {
                    <div class="inline-spinner"></div>
                  }
                  @if (!isLoadingMetrics && metrics) {
                    <span>{{
                      formatMetricValue(metrics.recountJournals)
                    }}</span>
                  }
                </div>
                <div class="metric-label">RECOUNT</div>
              </div>
              <div
                class="metric-item clickable"
                (click)="showJournalsByStatus('Completed')"
                (keydown.enter)="showJournalsByStatus('Completed')"
                tabindex="0"
                role="button"
                nbTooltip="View completed journals"
                nbTooltipPlacement="top"
                >
                <div
                  class="metric-value"
                  [style.color]="getJournalStatusColor('Completed')"
                  >
                  @if (isLoadingMetrics) {
                    <div class="inline-spinner"></div>
                  }
                  @if (!isLoadingMetrics && metrics) {
                    <span>{{
                      formatMetricValue(metrics.completedJournals)
                    }}</span>
                  }
                </div>
                <div class="metric-label">COMPLETE</div>
              </div>
            </div>
          </div>
          @if (!isLoadingMetrics && !metrics) {
            <div class="no-data">
              No data available
            </div>
          }
        </nb-card-body>
      </nb-card>
    </div>

    <!-- Line Summary Card -->
    <div class="col-md-6">
      <nb-card>
        <nb-card-header>
          <h6>LINE SUMMARY</h6>
        </nb-card-header>
        <nb-card-body style="overflow: visible; padding: 2rem 0rem 1rem 0rem">
          <div class="metrics-container">
            <div class="metric-row">
              <div
                class="metric-item clickable"
                (click)="showLinesByStatus(null)"
                (keydown.enter)="showLinesByStatus(null)"
                tabindex="0"
                role="button"
                nbTooltip="View all lines"
                nbTooltipPlacement="top"
                >
                <div class="metric-value">
                  @if (isLoadingMetrics) {
                    <div class="inline-spinner"></div>
                  }
                  @if (!isLoadingMetrics && metrics) {
                    <span>{{
                      formatMetricValue(metrics.totalLines)
                    }}</span>
                  }
                </div>
                <div class="metric-label">TOTAL</div>
              </div>
              <div
                class="metric-item clickable"
                (click)="showLinesByStatus('Counted')"
                (keydown.enter)="showLinesByStatus('Counted')"
                tabindex="0"
                role="button"
                nbTooltip="View counted lines"
                nbTooltipPlacement="top"
                >
                <div
                  class="metric-value"
                  [style.color]="getLineStatusColor('Counted')"
                  >
                  @if (isLoadingMetrics) {
                    <div class="inline-spinner"></div>
                  }
                  @if (!isLoadingMetrics && metrics) {
                    <span>{{
                      formatMetricValue(metrics.countedLines)
                    }}</span>
                  }
                </div>
                <div class="metric-label">COUNTED</div>
              </div>
              <div
                class="metric-item clickable"
                (click)="showLinesByStatus('Other Location')"
                (keydown.enter)="showLinesByStatus('Other Location')"
                tabindex="0"
                role="button"
                nbTooltip="View other location lines"
                nbTooltipPlacement="top"
                >
                <div
                  class="metric-value"
                  [style.color]="getLineStatusColor('Other_Location')"
                  >
                  @if (isLoadingMetrics) {
                    <div class="inline-spinner"></div>
                  }
                  @if (!isLoadingMetrics && metrics) {
                    <span>{{
                      formatMetricValue(metrics.otherLocationLines)
                    }}</span>
                  }
                </div>
                <div class="metric-label">OTHER LOC</div>
              </div>
              <div
                class="metric-item clickable"
                (click)="showLinesByStatus('Added')"
                (keydown.enter)="showLinesByStatus('Added')"
                tabindex="0"
                role="button"
                nbTooltip="View added lines"
                nbTooltipPlacement="top"
                >
                <div
                  class="metric-value"
                  [style.color]="getLineStatusColor('Added')"
                  >
                  @if (isLoadingMetrics) {
                    <div class="inline-spinner"></div>
                  }
                  @if (!isLoadingMetrics && metrics) {
                    <span>{{
                      formatMetricValue(metrics.addedLines)
                    }}</span>
                  }
                </div>
                <div class="metric-label">ADDED</div>
              </div>
              <div
                class="metric-item clickable"
                (click)="showLinesByStatus('Waiting Count')"
                (keydown.enter)="showLinesByStatus('Waiting Count')"
                tabindex="0"
                role="button"
                nbTooltip="View waiting count lines"
                nbTooltipPlacement="top"
                >
                <div
                  class="metric-value"
                  [style.color]="getLineStatusColor('Waiting_Count')"
                  >
                  @if (isLoadingMetrics) {
                    <div class="inline-spinner"></div>
                  }
                  @if (!isLoadingMetrics && metrics) {
                    <span>{{
                      formatMetricValue(metrics.waitingCountLines)
                    }}</span>
                  }
                </div>
                <div class="metric-label">WAITING</div>
              </div>
              <div
                class="metric-item clickable"
                (click)="showLinesByStatus('Not Found')"
                (keydown.enter)="showLinesByStatus('Not Found')"
                tabindex="0"
                role="button"
                nbTooltip="View not found lines"
                nbTooltipPlacement="top"
                >
                <div
                  class="metric-value"
                  [style.color]="getLineStatusColor('Not_Found')"
                  >
                  @if (isLoadingMetrics) {
                    <div class="inline-spinner"></div>
                  }
                  @if (!isLoadingMetrics && metrics) {
                    <span>{{
                      formatMetricValue(metrics.notFoundLines)
                    }}</span>
                  }
                </div>
                <div class="metric-label">NOT FOUND</div>
              </div>
            </div>
          </div>
          @if (!isLoadingMetrics && !metrics) {
            <div class="no-data">
              No data available
            </div>
          }
        </nb-card-body>
      </nb-card>
    </div>
  </div>

  <!-- Location Accuracy and Lost Equipment Section -->
  <div class="row mt-3">
    <!-- Location Accuracy Card -->
    <div class="col-md-6">
      <nb-card>
        <nb-card-header>
          <h6>LOCATION ACCURACY</h6>
        </nb-card-header>
        <nb-card-body style="overflow: visible; padding: 1.5rem">
          @if (isLoadingMetrics) {
            <div class="loading-container">
              <nb-spinner status="primary" size="medium"></nb-spinner>
            </div>
          }
          @if (!isLoadingMetrics && metrics) {
            <div
              class="accuracy-metrics-container"
              >
              <div class="accuracy-row">
                <!-- Accuracy Gauge -->
                <div class="accuracy-metric clickable">
                  <div
                    class="accuracy-metric-value"
                    (click)="showIncorrectLocationLines()"
                    (keydown.enter)="showIncorrectLocationLines()"
                    tabindex="0"
                    role="button"
                    [style.color]="getAccuracyColor()"
                    >
                    @if (
                      getAccuracyPercentage() > 99 &&
                      getAccuracyPercentage() < 100
                      ) {
                      &gt;99%
                    }
                    @if (
                      getAccuracyPercentage() <= 99 ||
                      getAccuracyPercentage() >= 100
                      ) {
                      {{
                      getAccuracyPercentage() | number: '1.0-0'
                      }}%
                    }
                  </div>
                  <div class="accuracy-metric-label">% ACCURACY</div>
                </div>
                <!-- Incorrect Location -->
                <div
                  class="accuracy-metric clickable"
                  (click)="showIncorrectLocationLines()"
                  (keydown.enter)="showIncorrectLocationLines()"
                  tabindex="0"
                  role="button"
                  >
                  <div class="accuracy-metric-value">
                    <span
                      class="percentage"
                      [style.color]="getIncorrectLocationColor()"
                      >
                      @if (
                        getIncorrectLocationPercentage() > 0 &&
                        getIncorrectLocationPercentage() < 1
                        ) {
                        &lt;1%
                      }
                      @if (
                        getIncorrectLocationPercentage() === 0 ||
                        getIncorrectLocationPercentage() >= 1
                        ) {
                        {{
                        getIncorrectLocationPercentage() | number: '1.0-0'
                        }}%
                      }
                    </span>
                    <span
                      class="separator"
                      [style.color]="getIncorrectLocationColor()"
                      >/</span
                      >
                      <span
                        class="count"
                        [style.color]="getIncorrectLocationColor()"
                        >{{
                        formatMetricValue(metrics.incorrectLocationCount || 0)
                        }}</span
                        >
                      </div>
                      <div class="accuracy-metric-label">INCORRECT LOCATION</div>
                    </div>
                    <!-- Incorrect Station -->
                    <div
                      class="accuracy-metric clickable"
                      (click)="showIncorrectStationLines()"
                      (keydown.enter)="showIncorrectStationLines()"
                      tabindex="0"
                      role="button"
                      >
                      <div class="accuracy-metric-value">
                        <span
                          class="percentage"
                          [style.color]="getIncorrectStationColor()"
                          >
                          @if (
                            getIncorrectStationPercentage() > 0 &&
                            getIncorrectStationPercentage() < 1
                            ) {
                            &lt;1%
                          }
                          @if (
                            getIncorrectStationPercentage() === 0 ||
                            getIncorrectStationPercentage() >= 1
                            ) {
                            {{
                            getIncorrectStationPercentage() | number: '1.0-0'
                            }}%
                          }
                        </span>
                        <span
                          class="separator"
                          [style.color]="getIncorrectStationColor()"
                          >/</span
                          >
                          <span
                            class="count"
                            [style.color]="getIncorrectStationColor()"
                            >{{
                            formatMetricValue(metrics.incorrectStationCount || 0)
                            }}</span
                            >
                          </div>
                          <div class="accuracy-metric-label">INCORRECT STATION</div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (!isLoadingMetrics && !metrics) {
                    <div class="no-data">
                      No data available
                    </div>
                  }
                </nb-card-body>
              </nb-card>
            </div>

            <!-- Lost Equipment Card -->
            <div class="col-md-6">
              <nb-card>
                <nb-card-header class="lost-equipment-header">
                  <h6>LOST EQUIPMENT</h6>
                  <button
                    nbButton
                    ghost
                    status="primary"
                    size="tiny"
                    (click)="showLostEquipmentDetails()"
                    nbTooltip="View more details"
                    nbTooltipPlacement="left"
                    >
                    More Details
                  </button>
                </nb-card-header>
                <nb-card-body style="overflow: visible; padding: 1.5rem">
                  @if (isLoadingMetrics) {
                    <div class="loading-container">
                      <nb-spinner status="primary" size="medium"></nb-spinner>
                    </div>
                  }
                  @if (!isLoadingMetrics && metrics) {
                    <div
                      class="lost-equipment-container"
                      >
                      <div class="lost-equipment-row">
                        <!-- Missing % / # -->
                        <div class="lost-metric clickable" (click)="showMissingLines()" (keydown.enter)="showMissingLines()" tabindex="0" role="button">
                          <div class="lost-metric-value">
                            <span class="percentage"
                              >{{ getMissingPercentage() | number: '1.0-0' }}%</span
                              >
                              <span class="separator">/</span>
                              <span class="count">{{
                                formatMetricValue(metrics.missingCount || 0)
                              }}</span>
                            </div>
                            <div class="lost-metric-label">MISSING</div>
                          </div>
                          <!-- Missing $ (Book Value) -->
                          <div class="lost-metric clickable" (click)="showMissingLines()" (keydown.enter)="showMissingLines()" tabindex="0" role="button">
                            <div class="lost-metric-value">
                              <span class="dollar-value">{{
                                formatCurrency(metrics.missingBookValue || 0)
                              }}</span>
                            </div>
                            <div class="lost-metric-label">$ MISSING</div>
                          </div>
                          <!-- Estimated Replacement Cost -->
                          <!-- <div class="lost-metric clickable" (click)="showMissingLines()">
                          <div class="lost-metric-value">
                            <span class="dollar-value">{{
                              formatCurrency(metrics.estimatedReplacementCost || 0)
                            }}</span>
                          </div>
                          <div class="lost-metric-label">EST REPLACEMENT COST</div>
                        </div> -->
                        <!-- Average Age -->
                        <div class="lost-metric">
                          <div class="lost-metric-value">
                            <span class="age-value">{{
                              formatAge(metrics.missingAvgAge || 0)
                            }}</span>
                          </div>
                          <div class="lost-metric-label">AVG AGE</div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (!isLoadingMetrics && !metrics) {
                    <div class="no-data">
                      No data available
                    </div>
                  }
                </nb-card-body>
              </nb-card>
            </div>
          </div>

          <!-- Disposition Code and Worker Analytics Section -->
          <div class="row mt-3">
            <!-- Disposition Code Chart -->
            <div class="col-md-8">
              <nb-card class="disposition-card">
                <nb-card-header>
                  <h6>DISPOSITION CODE BREAKDOWN</h6>
                </nb-card-header>
                <nb-card-body>
                  @if (isLoadingDispositionData) {
                    <div class="loading-container">
                      <nb-spinner status="primary" size="medium"></nb-spinner>
                    </div>
                  }
                  @if (!isLoadingDispositionData && dispositionData.length === 0) {
                    <div
                      class="no-data"
                      >
                      No disposition data available
                    </div>
                  }
                  @if (!isLoadingDispositionData && dispositionData.length > 0) {
                    <div
                      class="disposition-list"
                      >
                      @for (item of dispositionData; track item; let i = $index) {
                        <div
                          class="disposition-item"
                          (click)="showDispositionDetail(item.disposition)"
                          (keydown.enter)="showDispositionDetail(item.disposition)"
                          tabindex="0"
                          role="button"
                          >
                          <div class="disposition-row">
                            <div class="disposition-label">{{ item.disposition }}</div>
                            <div class="disposition-info">
                              <span class="disposition-count">{{
                                formatMetricValue(item.count)
                              }}</span>
                              <span class="disposition-percentage">
                                {{
                                getDispositionPercentage(item.count) | number: '1.0-0'
                                }}%
                              </span>
                            </div>
                          </div>
                          <div class="progress-wrapper">
                            <div
                              class="disposition-progress-bar"
                              [style.width]="getDispositionBarWidth(item.count)"
                              [style.background-color]="getDispositionColor(i)"
                            ></div>
                          </div>
                        </div>
                      }
                    </div>
                  }
                </nb-card-body>
              </nb-card>
            </div>

            <!-- Right column: Worker Counting Analytics -->
            <div class="col-md-4">
              <nb-card class="worker-analytics-card">
                <nb-card-header>
                  <h6>COUNT BY USER</h6>
                </nb-card-header>
                <nb-card-body>
                  <stack-mono-worker-counting-analytics
                    [externalFilters]="currentFilter"
                    [sortBy]="workerCountingSortBy"
            (workerClick)="
              showLinesByWorker($event.countedBy, $event.countedByName)
            "
                  ></stack-mono-worker-counting-analytics>
                </nb-card-body>
              </nb-card>
            </div>
          </div>
        </div>
